import React from 'react';
import { Link } from 'react-router-dom';

/**
 * AdminCard - Reusable card component for admin panel features
 * 
 * @param {ReactNode} icon - SVG icon element to display
 * @param {string} title - Card title
 * @param {string} description - Card description text
 * @param {string} linkTo - Route path to navigate to
 * @param {string} linkText - Button text (default: "Öppna")
 * @param {string} iconBgColor - Tailwind bg color class for icon container (default: "bg-leaf")
 */
export default function AdminCard({ 
    icon, 
    title, 
    description, 
    linkTo, 
    linkText = "Öppna",
    iconBgColor = "bg-leaf"
}) {
    return (
        <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden">
            <div className="p-6">
                <div className={`flex items-center justify-center w-12 h-12 ${iconBgColor} rounded-lg mb-4`}>
                    {icon}
                </div>
                <h2 className="font-heading text-2xl font-bold text-charcoal mb-2">
                    {title}
                </h2>
                <p className="text-gray-600 mb-6">
                    {description}
                </p>
            </div>
            <div className="px-6 pb-6">
                <Link 
                    to={linkTo}
                    className="block w-full text-center bg-forest hover:bg-leaf text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-300"
                >
                    {linkText}
                </Link>
            </div>
        </div>
    );
}
